/* eslint-disable */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

import * as _high_contrast_media_query from '../utils/high_contrast_media_query';

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

var styles = function styles(_ref) {
  var radioSize = _ref.radioSize,
    radioOffset = _ref.radioOffset,
    shouldAnimate = _ref.shouldAnimate,
    theme = _ref.theme;
  return {
    controls: _extends(
      {
        borderRadius: theme.borderRadius3,
        display: 'inline-flex',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        position: 'relative',
        '&::before': _extends(
          {
            background: theme && theme.palette?.primary.default,
            content: '""',
            height: '100%',
            left: 0,
            position: 'absolute',
            transform: 'translateX('.concat(radioOffset, 'px)'),
            transition: shouldAnimate && 'transform 0.3s ease, width 0.3s ease',
            width: radioSize,
            zIndex: 0
          },
          theme.mode === 'contrast' && {
            background: theme && theme.palette.primary.active
          }
        )
      },
      (0, _high_contrast_media_query.default)()
    ),
    mobile: {
      flexDirection: 'column',
      '&::before': {
        height: radioSize,
        transform: 'translateY('.concat(radioOffset, 'px)'),
        width: '100%'
      }
    }
  };
};

var _default = styles;
export default _default;
